import { DomSanitizer } from '@angular/platform-browser';
import {PipeTransform, Pipe} from '@angular/core';

@Pipe({ name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform  {
    constructor(private sanitized: DomSanitizer) {}
    transform(value) {
        if (value){
            return this.sanitized.bypassSecurityTrustHtml(value);
        }else {
            return '';
        }

    }
}
